<div (click)="bundletDetails(element)">
  <div class="product-card" [class.product-card-mobile]="isMobile">
    @if(calcDis(element.pricea,element.price) !== 0){
    <div class="discount-badge">
      {{calcDis(element.pricea,element.price)}}% {{ "discount" | transloco }}
    </div>
    }
    <div class="bundle-badge">
      {{ "deal" | transloco}}
    </div>
    <div class="col-12 product-img" [class.product-img-mobile]="isMobile">

      <div #bundleSwiper class="swiper bundle-swiper">

        <div class="swiper-wrapper">

          <div class="swiper-slide" *ngFor="let img of bundleSlides">
            <img [lazyLoad]="img" alt="  {{ 'deal' | transloco}}" />
          </div>

        </div>

        <!-- Pagination -->
        <div class="swiper-pagination"></div>

        <!-- Navigation -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>

      </div>

    </div>

    @if(isAr){

    <p class="product-name" [class.line-pc]="!isMobile" [class.line]="detectNumberofCharacters(element.name_ar)"
      [class.mt-3]="!isMobile" [class.product-name-mobile]="isMobile">
      {{element.name_ar}}
    </p>
    } @else {
    <p class="product-name" [class.line]="!isMobile" [class.line]="detectNumberofCharacters(element.name_en)"
      [class.mt-3]="!isMobile" [class.product-name-mobile]="isMobile">
      {{element.name_en}}
    </p>

    }

    <!-- Description OR Bundle Items -->
    <div *ngIf="!showBundleItems; else bundleTemplate">

      <!-- Description -->
      @if(isAr){
      <p class="product-name">
        {{element.description_ar}}
      </p>
      } @else {
      <p class="product-name">
        {{element.description_en}}
      </p>
      }

    </div>

    <!-- Bundle Items Template -->
    <ng-template #bundleTemplate>

      <div class="bundle-items-premium" *ngIf="element?.items?.length">

        <div class="bundle-chip" *ngFor="let item of element.items">

          <!-- Icon -->
          <div class="chip-img">
            <img [lazyLoad]="fixImage(item.stock.image)" alt="item" />
          </div>

          <!-- Text -->
          <div class="chip-text">

            <span class="chip-qty">
              ×{{ item.quantity }}
            </span>

            <span class="chip-name">
              {{ isAr ? item.stock.name_ar : item.stock.name_en }}
            </span>

          </div>

        </div>

      </div>

    </ng-template>


    <div class="d-flex justify-content-center align-items-center">
      <span class="new-price" [class.new-price-mobile]="isMobile">{{element.pricea}} {{ "egpe" | transloco }}</span>
      @if(calcDis(element.pricea,element.price) != 0){
      <span class="old-price" [class.new-price-mobile]="isMobile">{{element.price}} {{ "egpe" | transloco }}</span>
      }
    </div>
    <button class="btn btn-add show-btn" style="margin-bottom: 5px;"
      (click)="toggleBundleItems(); $event.stopPropagation()">

      {{ showBundleItems ? ("Show Description" | transloco) : ("Show Bundle Items" | transloco) }}

    </button>


    <button class="btn btn-add" (click)="addBundle (element); $event.stopPropagation()">
      {{ "addtocart" | transloco }}
    </button>

  </div>
</div>